var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c('div',{staticClass:"style-injector",domProps:{"innerHTML":_vm._s(_vm.style)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }